export const GET_REALTIME_REQUEST = "GET_REALTIME_REQUEST"
export const GET_REALTIME_SUCCESS = "GET_REALTIME_SUCCESS"
export const GET_REALTIME_FAILED = "GET_REALTIME_FAILED"


export const GetRealtimeAction = (userId:String,ipAddress:String,ipv6:String)=>{
    return{
        type:GET_REALTIME_REQUEST,payload: { userId,ipAddress,ipv6}
    }
}
